import api from 'services/api';

const toInt = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.trunc(parsed) : null;
};

const toFloat = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const toText = (value) => {
  if (value === null || value === undefined) {
    return null;
  }

  const text = String(value).trim();
  return text === '' ? null : text;
};

export const normalizeCtoClientes = (payload) => {
  const rows = Array.isArray(payload?.cto_clientes)
    ? payload.cto_clientes
    : (Array.isArray(payload) ? payload : []);

  return rows
    .filter((row) => row && typeof row === 'object' && toInt(row.id_onu) !== null)
    .map((row) => ({
      id_onu: toInt(row.id_onu),
      porta_ftth: toInt(row.porta_ftth),
      id_cliente: toInt(row.id_cliente),
      cliente: toText(row.cliente),
      id_contrato: toInt(row.id_contrato),
      status_contrato: toText(row.status_contrato),
      status_internet: toText(row.status_internet),
      sinal_rx: toFloat(row.sinal_rx),
      sinal_tx: toFloat(row.sinal_tx),
      data_sinal: toText(row.data_sinal),
      status_potencia: toText(row.status_potencia),
      causa_ultima_queda: toText(row.causa_ultima_queda),
      status_autorizado: toText(row.status_autorizado),
      login_ativo: toText(row.login_ativo),
      login_online: toText(row.login_online),
      classificacao_sinal: toText(row.classificacao_sinal),
      vinculado: row.vinculado === true || toInt(row.id_cliente) !== null,
    }));
};

class SinalCtoClientesService {
  async buscarClientesDaCto(idCto, signal = null) {
    const config = signal ? { signal } : {};
    const response = await api.get(`/infraestrutura/sinal/ctos/${idCto}/clientes`, config);

    return normalizeCtoClientes(response.data?.data ?? response.data);
  }
}

const sinalCtoClientesService = new SinalCtoClientesService();

export default sinalCtoClientesService;
